module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Book.f432921.woff";